import React from 'react';
import { Icon } from '@plone/volto/components';
import verifiziertSVG from '../../../icons/verifiziert.svg';

const WikiTitle = ({ content }) => {
  return (
    <div className={`wiki-title review-state-${content.review_state}`}>
      <h1 className="documentFirstHeading">{content.title}</h1>
      <p className="subheading">Version {content.version}</p>
      {content.review_state === 'verified' && (
        <Icon name={verifiziertSVG} size="1.75em" />
      )}
    </div>
  );
};

export default WikiTitle;
